import { Injectable, Inject } from '@angular/core';

import { WINDOW_TOKEN } from '../bootstrap.service';
import { StorageKeyBuilderService } from './storage-key-builder.service';
import { StorageType } from './storage-type.enum';
import { StorageKeyBuilderStrategy } from './storage-key-builder-strategy.enum';
import { BaseStorageService } from './base-storage.service';

/**
 * SessionStorageService
 * Injectable class to provide access and utility methods to browser's session storage
 */
@Injectable({
  providedIn: 'root'
})
export class SessionStorageService extends BaseStorageService {

  constructor(@Inject(WINDOW_TOKEN) browserWindow: Window,
              @Inject(StorageKeyBuilderService) storageKeyBuilderService: StorageKeyBuilderService) {
    super(
      browserWindow,
      storageKeyBuilderService,
      StorageKeyBuilderStrategy.KEY_USER_SESSION,
      StorageType.SESSION_STORAGE
    );
  }

  /**
   * removeItems
   * Loops through each key on the session storage and
   * tests for a pattern. If satisfied , calls storage
   * removeItem method directly to avoid double prefix
   *
   * @param keyPattern
   */
  public removeItems(keyPattern?: RegExp): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this;
    const pattern = keyPattern === undefined ? /^tdWb/ : keyPattern;

    this.forEach((key: unknown): void => {
      if (pattern.test(key as string)) {
        context.storage.removeItem(key as string);
      }
    });
  }

  /**
   * clearSessionStorage
   * Clears all sessionStorage items
   * To be used when user clicks logout
   */
  public clearSessionStorage(): void {
    this.storage.clear();
  }
}
